import React from 'react';
import { AuditView } from '@/components/views/AuditView';

export const AuditPage = () => {
	return <AuditView />;
};
